/** @format */

import { useEffect } from 'react';
import { Avatar } from './avatar';
import { CustomDropDown } from 'src/components/CustomDropDown/CustomDropDown';
import { useTranslation } from 'react-i18next';
import { UserDropdown } from './userDropdown';
import { updateUserProfilePicture } from 'src/slices/users';
import { useDispatch, useSelector } from 'src/store';

export const UserInfo = props => {
  const { data, logout } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userProfile } = useSelector(state => state.users);

  useEffect(() => {
    if (!userProfile?.picture && !userProfile?.error && !userProfile?.pictureLoading) {
      dispatch(updateUserProfilePicture());
    }
  }, [dispatch, userProfile?.picture, userProfile?.error, userProfile?.pictureLoading]);

  let user = data;
  return (
    <div className="userInfo">
      <CustomDropDown
        placement="bottomRight"
        overlayClassName="userInfoDropDown userInfoDropDown--menuPanel"
        keepMounted
        trigger={
          <div className="userInfoDetail__container">
            <div className="userInfoDetail">
              <p className="userInfoDetail__name">{user && user.firstName && `${user?.firstName} ${user?.lastName}`}</p>
            </div>
            <button type="button" className="userInfoDropDownButton ghost-button">
              <Avatar srcImg={userProfile?.picture || ''} name={`${user?.firstName} ${user?.lastName}`} />
            </button>
          </div>
        }>
        <UserDropdown logout={logout} />
      </CustomDropDown>
    </div>
  );
};
